import { render, staticRenderFns } from "./TuitionCollection.vue?vue&type=template&id=99257a60&lang=true"
import script from "./TuitionCollection.vue?vue&type=script&lang=js"
export * from "./TuitionCollection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports